@import '../../utils/forced-colors.css';

:host {
  --_divider-color: var(--color-divider-divider);
  --_divider-inset: 0;
  --_divider-length: 100%;

  display: block;
  flex-shrink: 0;
  width: var(--_divider-length);
  height: var(--dimension-stroke-width-012);
  margin: 0 var(--_divider-inset);
  border: none;
  background-color: var(--_divider-color);
}

:host(.divider--vertical) {
  width: var(--dimension-stroke-width-012);
  height: var(--_divider-length);
  min-height: var(--dimension-stroke-width-012);
  margin: var(--_divider-inset) 0;
  align-self: stretch;
}

:host(.divider--vertical.divider--custom-length) {
  align-self: center;
}

:host([background='bold']),
:host(.divider--background-bold) {
  --_divider-color: var(--color-divider-divider-on-bold-background);
}

:host([background='strong']),
:host(.divider--background-strong) {
  --_divider-color: var(--color-divider-divider-on-strong-background);
}

:host([background='medium']),
:host(.divider--background-medium) {
  --_divider-color: var(--color-divider-divider-on-medium-background);
}

:host([background='translucent']),
:host(.divider--background-translucent) {
  --_divider-color: var(--color-translucent-divider);
}

:host([background='navigation']),
:host(.divider--background-navigation) {
  --_divider-color: var(--color-navigation-divider);
}

:host([background='media']),
:host(.divider--background-media) {
  --_divider-color: var(--color-media-divider);
}

:host([background='always-dark']),
:host(.divider--background-always-dark) {
  --_divider-color: var(--color-always-dark-divider);
}

:host([background='inverted']),
:host(.divider--background-inverted) {
  --_divider-color: var(--color-inverted-divider);
}

@media (forced-colors: active) {
  :host {
    background-color: var(--ds-forced-color-content);
  }
}
